<template>
  <section v-if="isBlackFridayActive && promoBundlesOnCart">
    <div class="add-ons" v-if="showAddOns">
      <div class="add-ons__content">
        <div class="add-ons__title">Add-ons</div>
        <div class="add-ons__items">
          <AddOnsListCertifications
            v-if="!(promoBundleOneOnCart || promoBundleTwoOnCart)"
            :certifications="certifications"
            :selectedPlanCode="selectedPlanCode"
          />
          <AddOnsSkillDiveItems v-if="promoBundleTwoOnCart || promoFundamentalsBundleOnCart" />
        </div>
      </div>
    </div>
  </section>
  <section v-else-if="isLeapYearPromoActive && promoBundlesOnCart">
    <div class="add-ons" v-if="showAddOns">
      <div class="add-ons__content">
        <div class="add-ons__title">Add-ons</div>
        <div class="add-ons__items">
          <AddOnsListCertifications
            :certifications="certifications"
            :selectedPlanCode="selectedPlanCode"
          />
          <AddOnsSkillDiveItems />
        </div>
      </div>
    </div>
  </section>
  <section v-else>
    <div class="add-ons">
      <div class="add-ons__content">
        <div class="add-ons__title">Add-ons</div>
        <div class="add-ons__items">
          <AddOnsListCertifications
            :certifications="certifications"
            :selectedPlanCode="selectedPlanCode"
          />
          <AddOnsSkillDiveItems />
          <AddOnsListLVTItems />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { updateCart, priceDetailUpdates, promoProductBundleUtils } from '@/helpers/mixins'
import AddOnsListCertifications from '@/components/cart/add-ons/AddOnsListCertifications.vue'
import AddOnsSkillDiveItems from '@/components/cart/add-ons/AddOnsSkillDiveItems.vue'
import AddOnsListLVTItems from '@/components/cart/add-ons/AddOnsListLVTItems.vue'
import CONSTANTS from '@/constants'

export default {
  name: 'AddOns',
  mixins: [updateCart, priceDetailUpdates, promoProductBundleUtils],
  components: {
    AddOnsListCertifications,
    AddOnsSkillDiveItems,
    AddOnsListLVTItems,
  },
  props: {
    certifications: {
      type: Array,
      required: true,
    },
  },
  computed: {
    showAddOns() {
      if (this.promoBundleOneOnCart) return false
      if (this.promoBundleTwoOnCart && !this.showSkillDiveAddOns) return false
      if (this.promoBundleTwoOnCart) return true
      if (this.promoFundamentalsBundleOnCart) return true
      if (this.promoFundamentalsBundleOnCart && !this.showSkillDiveAddOns) return true
      if (!this.showSkillDiveAddOns) return true
      return true
    },
    showSkillDiveAddOns() {
      const plan = this.shoppingCart.find(
        item => item.merchant_id === CONSTANTS.PLANS.SKILL_DIVE_ANNUAL
      )
      if (!plan) return true
      return plan && plan.selectedAsAddOns
    },
  },
}
</script>

<style lang="scss" scoped>
.add-ons {
  &__content {
    margin: 20px 0;
    text-align: left;
  }
  &__title {
    font-weight: 700;
    font-size: rem(20px);
    line-height: 26px;
    margin-bottom: 10px;
  }
  &__items {
    display: flex;
    flex-flow: column;
    gap: 10px;
  }
}
</style>
